export default "__VITE_ASSET__CdvnQbXa__"